const NEIGHBORS_QUERY_KEY = 'document-neighbors';

export const neighborsKeys = {
  all: [NEIGHBORS_QUERY_KEY] as const,
  neighbors: (annotationId: number | null) =>
    [NEIGHBORS_QUERY_KEY, 'neighbors', annotationId] as const,
  annotationContent: (annotationId: number | null) =>
    [NEIGHBORS_QUERY_KEY, 'annotation-content', annotationId] as const,
  allAnnotationsMetadata: () =>
    [NEIGHBORS_QUERY_KEY, 'annotations-metadata'] as const,
  annotationsMetadata: (annotationIds: number[]) =>
    [NEIGHBORS_QUERY_KEY, 'annotations-metadata', annotationIds] as const,
  page: (annotationId: number | null, pageNumber: number) =>
    [NEIGHBORS_QUERY_KEY, 'page', annotationId, pageNumber] as const,
  pagePreview: (pageId: number | undefined) =>
    [NEIGHBORS_QUERY_KEY, 'page-preview', pageId] as const,
};
